import React from 'react';

import { connect } from 'react-redux';
import { Field, FieldArray, getFormValues, reduxForm } from 'redux-form';
import { Col, Form, Row } from 'react-bootstrap';
import { AddressFields } from '../../../../common/components/ReduxFormField';
import PostcodeList from '../../../../common/components/Postcode/PostcodeList';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import LlpPartner from './LlpPartner';
import {
  Box,
  Button,
  FormGroupRow,
  HorizontalFormControl,
  SelectLegalEntityType,
  SelectOrganisationType,
} from '../../../../common/components';

import './OrganisationForm.scss';
import { InternalButtonBar } from '../../../layout/components';
import MultiSelectMenu from '../../../../common/components/SelectMenu/MultiSelectMenu';

const FORM_NAME = 'organisationForm';

const OrganisationForm = ({
  resource,
  formValues,
  handleSubmit,
  onSave,
  submitting,
  location,
}) => {
  const resourceAttributes = resource.data.attributes;
  const organisationType = getIncludedResource(
    resource.data,
    resource.included,
    'organisation_type',
  );

  const legalEntityCode =
    formValues?.data?.relationships?.legal_entity_type?.data?.attributes?.code;

  const hasPartners = ['lp', 'llp'].includes(legalEntityCode);
  const hasProprietor = legalEntityCode === 'soletrader';

  const organisationTypeName =
    formValues?.data?.relationships?.organisation_type?.data?.attributes?.name ??
    organisationType?.data?.attributes?.name;
  const isBroker = organisationTypeName === 'Broker';

  const title = organisationTypeName
    ? organisationTypeName
    : location?.query?.organisationTypeName ?? 'Organisation';

  return (
    <Box>
      <h2 className="resource-name">{resourceAttributes.name}</h2>
      <Form onSubmit={handleSubmit(onSave)}>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.name"
              label="Name"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.relationships.organisation_type.data"
              label="Organisation Type"
              isObject
              labelSize={4}
              component={SelectOrganisationType}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.phone1"
              label="Phone 1"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              // name="data.attributes.regulatory_authority_number"
              name="data.attributes.legal_entity_number"
              label="FCA Number"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.phone2"
              label="Phone 2"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              name="data.relationships.legal_entity_type.data"
              label="Legal Entity Type"
              labelSize={4}
              isObject
              component={SelectLegalEntityType}
            />
          </Col>
        </Row>
        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.metadata.website"
              label="Website"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <FormGroupRow label="Channel Access" labelSize={4} fieldSize={8}>
              <Field
                name={'data.relationships.channel_access.data'}
                component={MultiSelectMenu}
                source={'channels'}
                sourceKey={'channelsOrgAccess'}
                filter={'?filter[channel_type]=B2B'}
                autoFilters={[{ type: 'name', notMatch: 'Fly-sure B2B' }]}
                isObject
              />
            </FormGroupRow>
          </Col>
          <Col sm={6}>
            {hasPartners && (
              <FieldArray
                name="data.attributes.metadata.partners"
                component={LlpPartner}
                fieldComponent={Field}
              />
            )}
            {hasProprietor && (
              <Field
                name="data.attributes.metadata.proprietor"
                label="Proprietor"
                labelSize={4}
                component={HorizontalFormControl}
              />
            )}
          </Col>
        </Row>

        {isBroker && (
          <Row>
            <Col sm={6}>
              <Field
                name="data.attributes.metadata.principal_company"
                label="Principal company"
                labelSize={4}
                component={HorizontalFormControl}
              />
            </Col>
          </Row>
        )}

        <Row>
          <Col sm={6}>
            <Field
              name="data.attributes.metadata.parent_company"
              label="Parent company"
              labelSize={4}
              component={HorizontalFormControl}
            />
          </Col>
          <Col sm={6}>
            <Field
              // name="data.attributes.legal_entity_number"
              name="data.attributes.metadata.company_registration_number"
              label="Company Registration Number"
              labelSize={4}
              object
              component={HorizontalFormControl}
            />
          </Col>
        </Row>

        <div className="hr" />
        <Row>
          <Col sm={6}>
            <PostcodeList
              name="data.attributes.address.postcode"
              label="Postcode"
              targetField={'data.attributes.address'}
              formName={FORM_NAME}
              labelSize={4}
              postcodeFieldSize={4}
              value={formValues?.data?.attributes?.address?.postcode}
            />
          </Col>
        </Row>

        <Row>
          <Col sm={6}>
            <AddressFields
              baseName="data.attributes.address"
              label="Address"
              labelSize={4}
            />
          </Col>
        </Row>

        <InternalButtonBar
          buttons={[
            {
              permissions: ['organisation.edit'],
              button: (
                <Button
                  className="pull-right"
                  type="submit"
                  bsStyle="primary"
                  label={`Save ${title}`}
                  isLoading={submitting}
                />
              ),
            },
          ]}
        />
      </Form>
    </Box>
  );
};

const form = reduxForm({ form: FORM_NAME })(OrganisationForm);

export default connect((state, ownProps) => ({
  initialValues: ownProps.resource,
  formValues: getFormValues(FORM_NAME)(state),
}))(form);
